export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

export const TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
export const TERMS_AND_CONDITIONS_SUCCESS = 'TERMS_AND_CONDITIONS_SUCCESS';
export const TERMS_AND_CONDITIONS_FAILURE = 'TERMS_AND_CONDITIONS_FAILURE';

export const GET_RELIGION_LIST = 'GET_RELIGION_LIST';
export const GET_RELIGION_SUCCESS = 'GET_RELIGION_SUCCESS';
export const GET_RELIGION_FAILURE = 'GET_RELIGION_FAILURE';

export const EDIT_RELIGION = 'EDIT_RELIGION';
export const EDIT_RELIGION_SUCCESS = 'EDIT__RELIGION_SUCCESS';
export const EDIT_RELIGION_FAILURE = 'EDIT__RELIGION_FAILURE';

export const ADD_RELIGION = 'ADD_RELIGION';
export const ADD_RELIGION_SUCCESS = 'ADD__RELIGION_SUCCESS';
export const ADD_RELIGION_FAILURE = 'ADD__RELIGION_FAILURE';

export const GET_EDUCATION_LIST = 'GET_EDUCATION_LIST';
export const GET_EDUCATION_SUCCESS = 'GET_EDUCATION_SUCCESS';
export const GET_EDUCATION_FAILURE = 'GET_EDUCATION_FAILURE';

export const GET_DOMAIN_DETAILS = 'GET_DOMAIN_DETAILS';
export const GET_DOMAIN_DETAILS_SUCCESS = 'GET_DOMAIN_DETAILS_SUCCESS';
export const GET_DOMAIN_DETAILS_FAILURE = 'GET_DOMAIN_DETAILS_FAILURE';

export const EDIT_INFLUENCER_USER = 'EDIT_INFLUENCER_USER';
export const EDIT_INFLUENCER_USER_SUCCESS = 'EDIT_INFLUENCER_USER_SUCCESS';
export const EDIT_INFLUENCER_USER_FAILURE = 'EDIT_INFLUENCER_USER_FAILURE';

export const EDIT_EDUCATION = 'EDIT_EDUCATION';
export const EDIT_EDUCATION_SUCCESS = 'EDIT__EDUCATION_SUCCESS';
export const EDIT_EDUCATION_FAILURE = 'EDIT__EDUCATION_FAILURE';

export const ADD_EDUCATION = 'ADD_EDUCATION';
export const ADD_EDUCATION_SUCCESS = 'ADD__EDUCATION_SUCCESS';
export const ADD_EDUCATION_FAILURE = 'ADD__EDUCATION_FAILURE';

export const GET_MESSAGE_DETAILS = 'GET_MESSAGE_DETAILS';
export const GET_MESSAGE_DETAILS_SUCCESS = 'GET_MESSAGE_DETAILS_SUCCESS';
export const GET_MESSAGE_DETAILS_FAILURE = 'GET_MESSAGE_DETAILS_FAILURE';

export const SEND_ADMIN_MESSAGE_RESPONSE = 'SEND_ADMIN_MESSAGE_RESPONSE';
export const SEND_ADMIN_MESSAGE_RESPONSE_SUCCESS = 'SEND_ADMIN_MESSAGE_RESPONSE_SUCCESS';
export const SEND_ADMIN_MESSAGE_RESPONSE_FAILURE = 'SEND_ADMIN_MESSAGE_RESPONSE_FAILURE';

export const GET_MYSELF_LIST = 'GET_MYSELF_LIST';
export const GET_MYSELF_SUCCESS = 'GET_MYSELF_SUCCESS';
export const GET_MYSELF_FAILURE = 'GET_MYSELF_FAILURE';

export const EDIT_MYSELF = 'EDIT_MYSELF';
export const EDIT_MYSELF_SUCCESS = 'EDIT__MYSELF_SUCCESS';
export const EDIT_MYSELF_FAILURE = 'EDIT__MYSELF_FAILURE';

export const ADD_MYSELF = 'ADD_MYSELF';
export const ADD_MYSELF_SUCCESS = 'ADD__MYSELF_SUCCESS';
export const ADD_MYSELF_FAILURE = 'ADD__MYSELF_FAILURE';

export const GET_HOBBIES_LIST = 'GET_HOBBIES_LIST';
export const GET_HOBBIES_SUCCESS = 'GET_HOBBIES_SUCCESS';
export const GET_HOBBIES_FAILURE = 'GET_HOBBIES_FAILURE';

export const EDIT_HOBBIES = 'EDIT_HOBBIES';
export const EDIT_HOBBIES_SUCCESS = 'EDIT__HOBBIES_SUCCESS';
export const EDIT_HOBBIES_FAILURE = 'EDIT__HOBBIES_FAILURE';

export const ADD_HOBBIES = 'ADD_HOBBIES';
export const ADD_HOBBIES_SUCCESS = 'ADD__HOBBIES_SUCCESS';
export const ADD_HOBBIES_FAILURE = 'ADD__HOBBIES_FAILURE';

export const GET_INTRESTED_LIST = 'GET_INTRESTED_LIST';
export const GET_INTRESTED_SUCCESS = 'GET_INTRESTED_SUCCESS';
export const GET_INTRESTED_FAILURE = 'GET_INTRESTED_FAILURE';

export const EDIT_INTRESTED = 'EDIT_INTRESTED';
export const EDIT_INTRESTED_SUCCESS = 'EDIT__INTRESTED_SUCCESS';
export const EDIT_INTRESTED_FAILURE = 'EDIT__INTRESTED_FAILURE';

export const ADD_INTRESTED = 'ADD_INTRESTED';
export const ADD_INTRESTED_SUCCESS = 'ADD__INTRESTED_SUCCESS';
export const ADD_INTRESTED_FAILURE = 'ADD__INTRESTED_FAILURE';

export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';

export const GET_RELATION_LIST = 'GET_RELATION_LIST';
export const GET_RELATION_SUCCESS = 'GET_RELATION_SUCCESS';
export const GET_RELATION_FAILURE = 'GET_RELATION_FAILURE';

export const GET_DREAM_LIST = 'GET_DREAM_LIST';
export const GET_DREAM_SUCCESS = 'GET_DREAM_SUCCESS';
export const GET_DREAM_FAILURE = 'GET_DREAM_FAILURE';

export const EDIT_DREAM = 'EDIT_DREAM';
export const EDIT_DREAM_SUCCESS = 'EDIT__DREAM_SUCCESS';
export const EDIT_DREAM_FAILURE = 'EDIT__DREAM_FAILURE';

export const ADD_DREAM = 'ADD_DREAM';
export const ADD_DREAM_SUCCESS = 'ADD__DREAM_SUCCESS';
export const ADD_DREAM_FAILURE = 'ADD__DREAM_FAILURE';

export const EDIT_RELATION = 'EDIT_RELATION';
export const EDIT_RELATION_SUCCESS = 'EDIT__RELATION_SUCCESS';
export const EDIT_RELATION_FAILURE = 'EDIT__RELATION_FAILURE';

export const ADD_RELATION = 'ADD_RELATION';
export const ADD_RELATION_SUCCESS = 'ADD__RELATION_SUCCESS';
export const ADD_RELATION_FAILURE = 'ADD__RELATION_FAILURE';

export const GET_SUB_USER_LIST = 'GET_SUB_USER_LIST';
export const GET_SUB_USER_LIST_SUCCESS = 'GET_SUB_USER_LIST_SUCCESS';
export const GET_SUB_USER_LIST_FAILURE = 'GET_SUB_USER_LIST_FAILURE';

export const GET_FREESUB_USER_LIST = 'GET_FREESUB_USER_LIST';
export const GET_FREESUB_USER_LIST_SUCCESS = 'GET_FREESUB_USER_LIST_SUCCESS';
export const GET_FREESUB_USER_LIST_FAILURE = 'GET_FREESUB_USER_LIST_FAILURE';

export const GET_PREMIUMSUB_USER_LIST = 'GET_PREMIUMSUB_USER_LIST';
export const GET_PREMIUMSUB_USER_LIST_SUCCESS = 'GET_PREMIUMSUB_USER_LIST_SUCCESS';
export const GET_PREMIUMSUB_USER_LIST_FAILURE = 'GET_PREMIUMSUB_USER_LIST_FAILURE';

export const GET_BLOOM_USER_LIST = 'GET_BLOOM_USER_LIST';
export const GET_BLOOM_USER_LIST_SUCCESS = 'GET_BLOOM_USER_LIST_SUCCESS';
export const GET_BLOOM_USER_LIST_FAILURE = 'GET_BLOOM_USER_LIST_FAILURE';

export const GET_FREE_USER_LIST = 'GET_FREE_USER_LIST';
export const GET_FREE_USER_LIST_SUCCESS = 'GET_FREE_USER_LIST_SUCCESS';
export const GET_FREE_USER_LIST_FAILURE = 'GET_FREE_USER_LIST_FAILURE';

export const GET_BLOOMSUB_USER_LIST = 'GET_BLOOMSUB_USER_LIST';
export const GET_BLOOMSUB_USER_LIST_SUCCESS = 'GET_BLOOMSUB_USER_LIST_SUCCESS';
export const GET_BLOOMSUB_USER_LIST_FAILURE = 'GET_BLOOMSUB_USER_LIST_FAILURE';

export const GET_PREMIUM_USER_LIST = 'GET_PREMIUM_USER_LIST';
export const GET_PREMIUM_USER_LIST_SUCCESS = 'GET_PREMIUM_USER_LIST_SUCCESS';
export const GET_PREMIUM_USER_LIST_FAILURE = 'GET_PREMIUM_USER_LIST_FAILURE';

export const GET_QUERY_USER_LIST = 'GET_QUERY_USER_LIST';
export const GET_QUERY_USER_LIST_SUCCESS = 'GET_QUERY_USER_LIST_SUCCESS';
export const GET_QUERY_USER_LIST_FAILURE = 'GET_QUERY_USER_LIST_FAILURE';

export const GET_QUERY_DETAILS = 'GET_QUERY_DETAILS';
export const GET_QUERY_DETAILS_SUCCESS = 'GET_QUERY_DETAILS_SUCCESS';
export const GET_QUERY_DETAILS_FAILURE = 'GET_QUERY_DETAILS_FAILURE';

export const SEND_ADMIN_QUERY_RESPONSE = 'SEND_ADMIN_QUERY_RESPONSE';
export const SEND_ADMIN_QUERY_RESPONSE_SUCCESS = 'SEND_ADMIN_QUERY_RESPONSE_SUCCESS';
export const SEND_ADMIN_QUERY_RESPONSE_FAILURE = 'SEND_ADMIN_QUERY_RESPONSE_FAILURE';

export const GET_MESSAGE_LIST = 'GET_MESSAGE_LIST';
export const GET_MESSAGE_LIST_SUCCESS = 'GET_MESSAGE_LIST_SUCCESS';
export const GET_MESSAGE_LIST_FAILURE = 'GET_MESSAGE_LIST_FAILURE';

export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';

export const GET_SUBSCRIPTION_DETAILS = 'GET_SUBSCRIPTION_DETAILS';
export const GET_SUBSCRIPTION_DETAILS_SUCCESS = 'GET_SUBSCRIPTION_DETAILS_SUCCESS';
export const GET_SUBSCRIPTION_DETAILS_FAILURE = 'GET_SUBSCRIPTION_DETAILS_FAILURE';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILURE = 'EDIT_USER_FAILURE';

export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

export const SEND_ADMIN_MESSAGE = 'SEND_ADMIN_MESSAGE';
export const SEND_ADMIN_MESSAGE_SUCCESS = 'SEND_ADMIN_MESSAGE_SUCCESS';
export const SEND_ADMIN_MESSAGE_FAILURE = 'SEND_ADMIN_MESSAGE_FAILURE';

export const ADD_USER_FREE_PREMIUM = 'ADD_USER_FREE_PREMIUM';
export const ADD_USER_FREE_PREMIUM_SUCCESS = 'ADD_USER_FREE_PREMIUM_SUCCESS';
export const ADD_USER_FREE_PREMIUM_FAILURE = 'ADD_USER_FREE_PREMIUM_FAILURE';

export const GET_DOMAIN_INFO_LIST = 'GET_DOMAIN_INFO_LIST';
export const GET_DOMAIN_INFO_LIST_SUCCESS = 'GET_DOMAIN_INFO_LIST_SUCCESS';
export const GET_DOMAIN_INFO_LIST_FAILURE = 'GET_DOMAIN_INFO_LIST_FAILURE';

export const ACCEPT_REJECT_DOMAIN = 'ACCEPT_REJECT_DOMAIN';
export const ACCEPT_REJECT_DOMAIN_SUCCESS = 'ACCEPT_REJECT_DOMAIN_SUCCESS';
export const ACCEPT_REJECT_DOMAIN_FAILURE = 'ACCEPT_REJECT_DOMAIN_FAILURE';

export const RESUME_SUSPEND_USER = 'RESUME_SUSPEND_USER';
export const RESUME_SUSPEND_USER_SUCCESS = 'RESUME_SUSPEND_USER_SUCCESS';
export const RESUME_SUSPEND_USER_FAILURE = 'RESUME_SUSPEND_USER_FAILURE';

export const OPEN_CLOSE_SUPPORT = 'OPEN_CLOSE_SUPPORT';
export const OPEN_CLOSE_SUPPORT_SUCCESS = 'OPEN_CLOSE_SUPPORT_SUCCESS';
export const OPEN_CLOSE_SUPPORT_FAILURE = 'OPEN_CLOSE_SUPPORT_FAILURE';

export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const PRIVACY_POLICY_SUCCESS = 'PRIVACY_POLICY_SUCCESS';
export const PRIVACY_POLICY_FAILURE = 'PRIVACY_POLICY_FAILURE';

export const TERM_CONDITION = 'TERM_CONDITION';
export const TERM_CONDITION_SUCCESS = 'TERM_CONDITION_SUCCESS';
export const TERM_CONDITION_FAILURE = 'TERM_CONDITION_FAILURE';

export const COOKIES = 'COOKIES';
export const COOKIES_SUCCESS = 'COOKIES_SUCCESS';
export const COOKIES_FAILURE = 'COOKIES_FAILURE';

export const ABOUT_US = 'ABOUT_US';
export const ABOUT_US_SUCCESS = 'ABOUT_US_SUCCESS';
export const ABOUT_US_FAILURE = 'ABOUT_US_FAILURE';

export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const GET_PRIVACY_POLICY_SUCCESS = 'GET_PRIVACY_POLICY_SUCCESS';
export const GET_PRIVACY_POLICY_FAILURE = 'GET_PRIVACY_POLICY_FAILURE';

export const GET_TERM_CONDITION = 'GET_TERM_CONDITION';
export const GET_TERM_CONDITION_SUCCESS = 'GET_TERM_CONDITION_SUCCESS';
export const GET_TERM_CONDITION_FAILURE = 'GET_TERM_CONDITION_FAILURE';

export const GET_COOKIES = 'GET_COOKIES';
export const GET_COOKIES_SUCCESS = 'GET_COOKIES_SUCCESS';
export const GET_COOKIES_FAILURE = 'GET_COOKIES_FAILURE';

export const GET_ABOUT_US = 'GET_ABOUT_US';
export const GET_ABOUT_US_SUCCESS = 'GET_ABOUT_US_SUCCESS';
export const GET_ABOUT_US_FAILURE = 'GET_ABOUT_US_FAILURE';

export const SUBSCRIPTION_POLICY = ' SUBSCRIPTION_POLICY';
export const SUBSCRIPTION_POLICY_SUCCESS = ' SUBSCRIPTION_POLICY_SUCCESS';
export const SUBSCRIPTION_POLICY_FAILURE = ' SUBSCRIPTION_POLICY_FAILURE';

export const GET_SUBSCRIPTION_POLICY = 'GET_SUBSCRIPTION_POLICY';
export const GET_SUBSCRIPTION_POLICY_SUCCESS = 'GET_SUBSCRIPTION_POLICY_SUCCESS';
export const GET_SUBSCRIPTION_POLICY_FAILURE = 'GET_SUBSCRIPTION_POLICY_FAILURE';

export const UPDATE_ADMIN_PROFILE = 'UPDATE_ADMIN_PROFILE';
export const UPDATE_ADMIN_PROFILE_SUCCESS = 'UPDATE_ADMIN_PROFILE_SUCCESS';
export const UPDATE_ADMIN_PROFILE_FAILURE = 'UPDATE_ADMIN_PROFILE_FAILURE';

export const GET_ADMIN_PROFILE = 'GET_ADMIN_PROFILE';
export const GET_ADMIN_PROFILE_SUCCESS = 'GET_ADMIN_PROFILE_SUCCESS';
export const GET_ADMIN_PROFILE_FAILURE = 'GET_ADMIN_PROFILE_FAILURE';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const REMEMBER_ME = 'REMEMBER_ME';

export const UPDATE_HOME_DATA = 'UPDATE_HOME_DATA';
export const UPDATE_HOME_DATA_SUCCESS = 'UPDATE_HOME_DATA_SUCCESS';
export const UPDATE_HOME_DATA_FAILURE = 'UPDATE_HOME_DATA_FAILURE';

export const GET_HOME_DATA = 'GET_HOME_DATA';
export const GET_HOME_DATA_SUCCESS = 'GET_HOME_DATA_SUCCESS';
export const GET_HOME_DATA_FAILURE = 'GET_HOME_DATA_FAILURE';
export const TOGGLE_SUBNAV = 'TOGGLE_SUBNAV';

export const GET_ETHNICITY_LIST = 'GET_ETHNICITY_LIST';
export const GET_ETHNICITY_SUCCESS = 'GET_ETHNICITY_SUCCESS';
export const GET_ETHNICITY_FAILURE = 'GET_ETHNICITY_FAILURE';

export const EDIT_ETHNICITY = 'EDIT_ETHNICITY';
export const EDIT_ETHNICITY_SUCCESS = 'EDIT__ETHNICITY_SUCCESS';
export const EDIT_ETHNICITY_FAILURE = 'EDIT__ETHNICITY_FAILURE';

export const ADD_ETHNICITY = 'ADD_ETHNICITY';
export const ADD_ETHNICITY_SUCCESS = 'ADD__ETHNICITY_SUCCESS';
export const ADD_ETHNICITY_FAILURE = 'ADD__ETHNICITY_FAILURE';

export const GET_USERS_FEEDBACK_LIST = 'GET_USERS_FEEDBACK_LIST';
export const GET_USERS_FEEDBACK_LIST_SUCCESS = 'GET_USERS_FEEDBACK_LIST_SUCCESS';
export const GET_USERS_FEEDBACK_LIST_FAILURE = 'GET_USERS_FEEDBACK_LIST_FAILURE';

export const GET_INVITE_FRIENDS_LIST = 'GET_INVITE_FRIENDS_LIST';
export const GET_INVITE_FRIENDS_LIST_SUCCESS = 'GET_INVITE_FRIENDS_LIST_SUCCESS';
export const GET_INVITE_FRIENDS_LIST_FAILURE = 'GET_INVITE_FRIENDS_LIST_FAILURE';
